import { dialog } from "nq-component";
import BaseListPresenter from "../../../../../base/BaseListPresenter";
import DialogModal from "../../../../../components/Dialog";
import {
  format,
  startOfDay,
  addHours,
  addMinutes,
  addDays,
  parseISO,
} from "date-fns";
import { auditLogUseCase } from "../../../../../usecases/logs";

class UpcomingRequestPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase
  ) {
    super(view, findObjectUseCase, deleteObjectUseCase);
    this.findObjectUseCase = findObjectUseCase;
    this.countObjectUseCase = countObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.upsertUseCase = upsertUseCase;
  }

  init() {
    const user = this.view.getCurrentUser();
    console.log("user", user);
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    console.log("hasAdminRole", hasAdminRole);
    this.where = hasAdminRole ? {} : { "sourceLocation.id": { $eq: storeId } };
    this.limit = 20;
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects() {
    this.reset();
    await this.countObjects();
    await this.findObjects();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
      },
      include: this.include,
      count: true,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  async countObjects() {
    try {
      this.showProgress();
      const collection = this.view.getCollectionName();
      const query = this.createQuery();
      const { count } = await this.countObjectUseCase.execute(collection, {
        where: query.where,
      });
      this.count = count;
      this.view.setCount(this.count);
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      console.log("this.object", this.objects);
      this.view.setObjects(this.objects);
      this.view.setCount(this.count);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onChangeDate(where) {
    const { created } = where;

    if (!created || !created.$gte || !created.$lte) {
      this.filterDate = {};
      this.reset();
      this.getObjects();
      return;
    }

    const startDate = addHours(startOfDay(parseISO(created.$gte)), 5);
    const endDate = addMinutes(
      addHours(addDays(startOfDay(parseISO(created.$lte)), 0), 4),
      59
    );

    this.filterDate = {
      requestDate: {
        $gte: startDate,
        $lte: endDate,
      },
    };

    this.getObjects();
  }

  onClickAdd() {
    this.view.navigateTo("/collection/stock_request/form");
  }

  onClickEdit(index) {
    const object = this.objects[index];
    this.view.navigateTo("/collection/upcoming_request/form/" + object.id);
  }

  async onClickDelete(index) {
    dialog.close();
    const object = this.objects[index];
    const collection = this.view.getCollectionName();

    await this.deleteObjectUseCase.execute(collection, object.id);
    const indexes = this.objects.indexOf(object.id);
    this.objects.splice(indexes, 1);
    this.view.setObjects(this.objects);
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Deleted Successfully"
          message=""
          isCancelButton={false}
          onSubmit={() => {
            dialog.close();
          }}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  async onDisapproveSubmit(index, reason) {
    const user = this.view.getCurrentUser();
    const collection = this.view.getCollectionName();
    const now = new Date();
    const currentTimestamp = now.toISOString();

    const object = this.objects[index];

    const updatePayload = {
      id: object.id,
      status: "Disapproved",
      reason: reason,
    };

    console.log("object", updatePayload);
    const result = await this.upsertUseCase.execute(collection, updatePayload);

    await auditLogUseCase().create({
      user: { id: user.id },
      logDate: currentTimestamp,
      message: `Disapprove stock request ${object.requestNumber} with reason "${reason}" (s)`,
      collection,
      objectId: object.id,
      payload: {
        request: object,
        response: updatePayload,
      },
      store: { id: user.storeAnalytic?.[0]?.id },
    });

    const findTransfer = await this.findObjectUseCase.execute(
      "stock_transfers",
      { where: { linkedRequestId: object.id } }
    );
    console.log("findtrans", findTransfer);

    const existingTransfer = findTransfer[0];

    if (existingTransfer) {
      // 📦 Update the status and append to logsArray
      const existingLogs = existingTransfer.logsArray || [];

      const newLog = {
        status: "Disapproved",
        timestamp: currentTimestamp,
        updatedBy: {
          id: user.id,
          name: user.username || user.email,
        },
        remarks: reason,
      };
      const updatedLogs = [...existingLogs, newLog];
      const updatedTransfer = {
        id: existingTransfer.id,
        status: "Disapproved",
        logsArray: updatedLogs,
      };

      console.log("Update", updatedTransfer);

      await this.upsertUseCase.execute("stock_transfers", updatedTransfer);

      // 📝 Optional: Audit log for transfer update
      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Updated stock transfer ${existingTransfer.transferNumber} to Disapproved`,
        collection: "stock_transfers",
        objectId: existingTransfer.id,
        payload: {
          transfer: existingTransfer,
          update: updatedTransfer,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });
    }

    // this.getObjects();
    dialog.close();

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Saved Successfully"
          message=""
          isCancelButton={false}
          onSubmit={
            // this.view.navigateBack();
            () => dialog.close()
          }
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  async onDispatchSubmit(index, estimatedTime) {
    const user = this.view.getCurrentUser();
    const collection = this.view.getCollectionName();
    const now = new Date();
    const currentTimestamp = now.toISOString();

    const object = this.objects[index];

    const updatePayload = {
      id: object.id,
      status: "Dispatched",
      estimatedDeliveryTime: estimatedTime,
    };

    console.log("object", updatePayload);
    const result = await this.upsertUseCase.execute(collection, updatePayload);

    await auditLogUseCase().create({
      user: { id: user.id },
      logDate: currentTimestamp,
      message: `Dispatched stock request ${object.requestNumber} with estimated time "${estimatedTime}" (s)`,
      collection,
      objectId: object.id,
      payload: {
        request: object,
        response: updatePayload,
      },
      store: { id: user.storeAnalytic?.[0]?.id },
    });

    const findTransfer = await this.findObjectUseCase.execute(
      "stock_transfers",
      { where: { linkedRequestId: object.id } }
    );
    console.log("findtrans", findTransfer);

    const existingTransfer = findTransfer[0];

    if (existingTransfer) {
      // 📦 Update the status and append to logsArray
      const existingLogs = existingTransfer.logsArray || [];

      const newLog = {
        status: "Dispatched",
        timestamp: currentTimestamp,
        updatedBy: {
          id: user.id,
          name: user.username || user.email,
        },
        remarks: estimatedTime,
      };
      const updatedLogs = [...existingLogs, newLog];
      const updatedTransfer = {
        id: existingTransfer.id,
        status: "Dispatched",
        logsArray: updatedLogs,
      };

      console.log("Update", updatedTransfer);

      await this.upsertUseCase.execute("stock_transfers", updatedTransfer);

      // 📝 Optional: Audit log for transfer update
      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Updated stock transfer ${existingTransfer.transferNumber} to Dispatched`,
        collection: "stock_transfers",
        objectId: existingTransfer.id,
        payload: {
          transfer: existingTransfer,
          update: updatedTransfer,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });
    }

    // this.getObjects();
    dialog.close();
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Saved Successfully"
          message=""
          isCancelButton={true}
          onSubmit={
            // this.view.navigateBack();
            () => dialog.close()
          }
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
    this.getObjects();
  }

  async onClickApproveReceive(index) {
    this.view.showProgressDialog();
    const user = this.view.getCurrentUser();
    const collection = this.view.getCollectionName();
    const now = new Date();
    const currentTimestamp = now.toISOString();

    const object = this.view.state.objects[index];

    const updatePayload = {
      id: object.id,
      status: "Completed",
    };

    // Get store IDs
    const receiverStoreId = object.requestedBy?.storeAnalytic?.[0]?.id;
    const senderStoreId = user.storeAnalytic?.[0]?.id;

    // Loop through items and update inventories
    for (const item of object.items || []) {
      const productId = item.itemName;

      const approvedQty = parseFloat(
        item.remainingQty || item.quantityApprove || item.quantity || 0
      );
      if (!productId || isNaN(approvedQty) || approvedQty <= 0) continue;

      // Deduct from sender inventory
      const [senderInventory] = await this.findObjectUseCase.execute(
        "inventory",
        {
          where: {
            itemName: productId,
            "storeId.id": senderStoreId,
          },
          limit: 1,
        }
      );

      if (senderInventory) {
        const updatedSenderQty = Math.max(
          parseFloat(senderInventory.systemCount || 0) - approvedQty,
          0
        );

        await this.upsertUseCase.execute("inventory", {
          id: senderInventory.id,
          systemCount: String(updatedSenderQty),
        });

        await auditLogUseCase().create({
          user: { id: user.id },
          logDate: currentTimestamp,
          message: `Deducted ${approvedQty} of ${item.itemName} from sender store.`,
          collection: "inventory",
          objectId: senderInventory.id,
          payload: {
            beforeUpdate: senderInventory,
            updatedQty: updatedSenderQty,
          },
          store: { id: senderStoreId },
        });
      }

      // Add to receiver inventory
      const [receiverInventory] = await this.findObjectUseCase.execute(
        "inventory",
        {
          where: {
            itemName: productId,
            "storeId.id": receiverStoreId,
          },
          limit: 1,
        }
      );

      let receiverNewQty = approvedQty;
      let receiverPayload;

      if (receiverInventory) {
        receiverNewQty += parseFloat(receiverInventory.systemCount || 0);
        receiverPayload = {
          id: receiverInventory.id,
          systemCount: String(receiverNewQty),
        };
      } else {
        receiverPayload = {
          item: { id: productId },
          storeId: { id: receiverStoreId },
          systemCount: String(receiverNewQty),
        };
      }

      await this.upsertUseCase.execute("inventory", receiverPayload);

      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Received ${approvedQty} of ${item.itemName} into receiver inventory.`,
        collection: "inventory",
        objectId: receiverPayload.id,
        payload: { beforeUpdate: receiverInventory, receiverPayload },
        store: { id: receiverStoreId },
      });
    }

    const result = await this.upsertUseCase.execute(collection, updatePayload);

    await auditLogUseCase().create({
      user: { id: user.id },
      logDate: currentTimestamp,
      message: `Completed stock request ${object.requestNumber}" (s)`,
      collection,
      objectId: object.id,
      payload: {
        request: object,
        response: updatePayload,
      },
      store: { id: user.storeAnalytic?.[0]?.id },
    });

    const findTransfer = await this.findObjectUseCase.execute(
      "stock_transfers",
      { where: { linkedRequestId: object.id } }
    );
    console.log("findtrans", findTransfer);

    const existingTransfer = findTransfer[0];

    if (existingTransfer) {
      // Update the status and append to logsArray
      const existingLogs = existingTransfer.logsArray || [];

      const newLog = {
        status: "Completed",
        timestamp: currentTimestamp,
        updatedBy: {
          id: user.id,
          name: user.username || user.email,
        },
        remarks: object?.remarks,
      };
      const updatedLogs = [...existingLogs, newLog];
      const updatedTransfer = {
        id: existingTransfer.id,
        status: "Completed",
        logsArray: updatedLogs,
      };

      console.log("Update", updatedTransfer);

      await this.upsertUseCase.execute("stock_transfers", updatedTransfer);

      // Audit log for transfer update
      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Updated stock transfer ${existingTransfer.transferNumber} to Completed`,
        collection: "stock_transfers",
        objectId: existingTransfer.id,
        payload: {
          transfer: existingTransfer,
          update: updatedTransfer,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });
    }

    // this.getObjects();
    this.view.hideProgressDialog();
    dialog.close();
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Saved Successfully"
          message=""
          isCancelButton={true}
          onSubmit={this.closeModal()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  async onApprovePartialRequest(index) {
    this.view.showProgressDialog();
    const user = this.view.getCurrentUser();
    const collection = this.view.getCollectionName();
    const now = new Date();
    const currentTimestamp = now.toISOString();

    const object = this.view.state.objects[index];

    const updatePayload = {
      id: object.id,
      status: "Partially Received",
    };

    // Get store IDs
    const receiverStoreId = object.requestedBy?.storeAnalytic?.[0]?.id;
    const senderStoreId = user.storeAnalytic?.[0]?.id;

    // Loop through items and update inventories
    for (const item of object.items || []) {
      const productId = item.itemName;

      const approvedQty = parseFloat(
        item.quantityReceive || item.quantity || 0
      );
      if (!productId || isNaN(approvedQty) || approvedQty <= 0) continue;

      // Deduct from sender inventory
      const [senderInventory] = await this.findObjectUseCase.execute(
        "inventory",
        {
          where: {
            itemName: productId,
            "storeId.id": senderStoreId,
          },
          limit: 1,
        }
      );

      if (senderInventory) {
        const updatedSenderQty = Math.max(
          parseFloat(senderInventory.systemCount || 0) - approvedQty,
          0
        );

        console.log("aa", {
          id: senderInventory.id,
          systemCount: String(updatedSenderQty),
        });

        await this.upsertUseCase.execute("inventory", {
          id: senderInventory.id,
          systemCount: String(updatedSenderQty),
        });

        await auditLogUseCase().create({
          user: { id: user.id },
          logDate: currentTimestamp,
          message: `Deducted ${approvedQty} of ${item.itemName} from sender store.`,
          collection: "inventory",
          objectId: senderInventory.id,
          payload: {
            beforeUpdate: senderInventory,
            updatedQty: updatedSenderQty,
          },
          store: { id: senderStoreId },
        });
      }

      // Add to receiver inventory
      const [receiverInventory] = await this.findObjectUseCase.execute(
        "inventory",
        {
          where: {
            itemName: productId,
            "storeId.id": receiverStoreId,
          },
          limit: 1,
        }
      );

      let receiverNewQty = approvedQty;
      let receiverPayload;

      if (receiverInventory) {
        receiverNewQty += parseFloat(receiverInventory.systemCount || 0);
        receiverPayload = {
          id: receiverInventory.id,
          systemCount: String(receiverNewQty),
        };
      } else {
        receiverPayload = {
          item: { id: productId },
          storeId: { id: receiverStoreId },
          systemCount: String(receiverNewQty),
        };
      }

      console.log("re", receiverPayload);

      await this.upsertUseCase.execute("inventory", receiverPayload);

      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Received ${approvedQty} of ${item.itemName} into receiver inventory.`,
        collection: "inventory",
        objectId: receiverPayload.id,
        payload: { beforeUpdate: receiverInventory, receiverPayload },
        store: { id: receiverStoreId },
      });
    }

    const result = await this.upsertUseCase.execute(collection, updatePayload);

    await auditLogUseCase().create({
      user: { id: user.id },
      logDate: currentTimestamp,
      message: `Partially Received stock request ${object.requestNumber}" (s)`,
      collection,
      objectId: object.id,
      payload: {
        request: object,
        response: updatePayload,
      },
      store: { id: user.storeAnalytic?.[0]?.id },
    });

    const findTransfer = await this.findObjectUseCase.execute(
      "stock_transfers",
      { where: { linkedRequestId: object.id } }
    );
    console.log("findtrans", findTransfer);

    const existingTransfer = findTransfer[0];

    if (existingTransfer) {
      // Update the status and append to logsArray
      const existingLogs = existingTransfer.logsArray || [];

      const newLog = {
        status: "Partially Received",
        timestamp: currentTimestamp,
        updatedBy: {
          id: user.id,
          name: user.username || user.email,
        },
        remarks: object?.remarks,
      };
      const updatedLogs = [...existingLogs, newLog];
      const updatedTransfer = {
        id: existingTransfer.id,
        status: "Partially Received",
        logsArray: updatedLogs,
      };

      console.log("Update", updatedTransfer);

      await this.upsertUseCase.execute("stock_transfers", updatedTransfer);

      // Audit log for transfer update
      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Updated stock transfer ${existingTransfer.transferNumber} to Partially Received`,
        collection: "stock_transfers",
        objectId: existingTransfer.id,
        payload: {
          transfer: existingTransfer,
          update: updatedTransfer,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });
    }

    // this.getObjects();
    this.view.hideProgressDialog();
    dialog.close();
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Saved Successfully"
          message=""
          isCancelButton={true}
          onSubmit={this.closeModal()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  closeModal() {
    dialog.close();
    this.view.reload();
  }

  onClickApproveRequest(index) {
    const object = this.objects[index];
    this.view.navigateTo(
      "/collection/upcoming_request/form/" + object.id + "/approve"
    );
  }

  onApproveReconcile(index) {
    const object = this.objects[index];
    this.view.navigateTo(
      "/collection/upcoming_request/form/" + object.id + "/reconciliation"
    );
  }

  onClickImport() {}
  onClickExport() {}
}

export default UpcomingRequestPresenter;
